/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {VersionReadyDialogComponent} from 'compob2b-libs';
import {filter, tap} from 'rxjs/operators';
import {NbDialogService} from '@nebular/theme';

@Component({
  selector: 'app-compo-admin',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private open = false;

  constructor(private swUpdate: SwUpdate,
              private dialogService: NbDialogService) {
  }

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        tap(console.warn),
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      ).subscribe(_ => {
        if (this.open) {
          return;
        }
        this.open = true;
        this.dialogService.open(VersionReadyDialogComponent, {
          dialogClass: 'simple',
          hasBackdrop: false,
          closeOnBackdropClick: false,
          closeOnEsc: false
        });
      });
    }
  }
}

